// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-benchmarking {
  position: absolute;
  width: 80vw;
  height: 87vh;
  margin-top: calc(8.3333333333vh + 15px);
  border-radius: 10px;
  background: white;
  left: 18.5vw;
  overflow-x: hidden;
  padding: 20px 25px;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Content.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACF","sourcesContent":[".content-benchmarking {\n  position: absolute;\n  width: 80vw;\n  height: 87vh;\n  margin-top: calc(100vh / 12 + 15px);\n  border-radius: 10px;\n  background: white;\n  left: 18.5vw;\n  overflow-x: hidden;\n  padding: 20px 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
